import React from "react";

import { LoadingIcon } from "@packages/ds";

import consoleConfig from "console_config";
import { loadingListSelector } from "Reducers/organization/subscription";
import { useAppSelector } from "Store/hooks";

import OrganizationItemContent from "./OrganizationItemContent";
import * as S from "./OrganizationMenu.styles";

type OrganizationListItemProps = {
  isActive: boolean;
  onClick: () => void;
  label: string;
  vendor: string;
  showVendor?: boolean;
};

const OrganizationListItem = ({
  isActive,
  onClick,
  label,
  vendor,
  showVendor
}: OrganizationListItemProps) => {
  const isLoadingOrganizationSubscriptions =
    useAppSelector(loadingListSelector);

  return (
    <S.OrganizationListItem
      $isActive={isActive}
      onClick={onClick}
      tabIndex={0}
      role="button"
      onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <OrganizationItemContent
        label={label}
        vendor={vendor}
        showVendor={consoleConfig.CUSTOM_ORGANIZATION_VENDORS && showVendor}
      />
      {isActive &&
        (isLoadingOrganizationSubscriptions ? (
          <LoadingIcon />
        ) : (
          <S.OrganizationListTick />
        ))}
    </S.OrganizationListItem>
  );
};

export default OrganizationListItem;
